import React from 'react';
import { EDPNQuestion } from '../../utils/Definitions';

interface Props {
    EDPNQuestion: EDPNQuestion,
    requiredQuestionsAsterisk: EDPNQuestion[],
}

export const EDPNRequiredAsterisk: React.FC<Props> = (props) => {

    const requiredQuestion = props.requiredQuestionsAsterisk.some(
        (q) => q.questionId === props.EDPNQuestion.questionId
    );

    return (
        <>
            {requiredQuestion && <span className="text-rose">*</span>}:
        </>
    )
};